import { Component, OnInit } from '@angular/core';
import {RoutesConst} from '@carm/shared/constants/const-routes';
import { setDateWithOffset } from '@carm/shared/functions/common-functions';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { DashboardCountService } from '@carm/_core/dashboard-count/services/dashboard-count.service';
import { BaseComponent } from '@carm/_utils/base.component';
import { combineLatest } from 'rxjs';
import { last, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'carm-penalties',
  templateUrl: './penalties.component.html',
  styleUrls: ['./penalties.component.scss']
})
export class PenaltiesComponent extends BaseComponent implements OnInit {

  public penalties;
  public viewAllPenaltiesUrl: string;
  public loading = true;

  constructor(
    private dashboardCountService: DashboardCountService,
    private carmRouter: CarmRouter
  ) {
    super();
  }

  ngOnInit(): void {
    this.viewAllPenaltiesUrl = RoutesConst.Enforcement_Actions;
    this.getPenalties();
  }

  private getPenalties() {
    const minDate = setDateWithOffset(0, 0, -90);
    const maxDate = setDateWithOffset(0, 0, 0);

    combineLatest([
      this.carmRouter.bn9$,
      this.carmRouter.bn15$,
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([bn9, programId]) => {

      this.loading = true;

      this.dashboardCountService.getPenaltiesCount(bn9, programId, minDate, maxDate)
      .pipe(takeUntil(this.destroy$), last())
      .subscribe(getPenaltiesResponse => {

          this.loading = false;
          this.penalties = getPenaltiesResponse?.recordCount || 0;
        },
        () => {
          this.loading = false;
        });
    }, () => this.loading = false);
  }

}
